
import React from 'react';
import { Loader2 } from 'lucide-react';

interface LoadingSpinnerProps {
    text?: string;
    fullHeight?: boolean;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
    text = "Loading...",
    fullHeight = false
}) => {
    return (
        <div className={`flex flex-col items-center justify-center ${fullHeight ? 'h-full min-h-[200px]' : 'p-4'}`}>
            <Loader2 className="h-8 w-8 animate-spin text-primary mb-2" />
            <span className="text-sm text-muted-foreground">{text}</span>
        </div>
    );
};
